import { memo, forwardRef } from "react";
import clsx from "clsx";
import { SnackbarContent } from "notistack";
import { amber, blue, green } from "@mui/material/colors";
import { styled } from "@mui/material";

const NotifierTheme = forwardRef((props, forwardedRef) => {
  const { message, variant, iconVariant, action } = props;

  return (
    <Root>
      <SnackbarContent
        ref={forwardedRef}
        className={clsx(classes.snackbar, classes[variant])}
      >
        <div className={classes.message}>
          {iconVariant[variant]}{" "}
          <div className={classes.messageText}>{message}</div>
          <div className={classes.close}>{action(props.id)}</div>
        </div>
      </SnackbarContent>
    </Root>
  );
});

export default memo(NotifierTheme);

const PREFIX = "Theme";

const classes = {
  snackbar: `${PREFIX}-snackbar`,
  default: `${PREFIX}-default`,
  success: `${PREFIX}-success`,
  error: `${PREFIX}-error`,
  warning: `${PREFIX}-warning`,
  info: `${PREFIX}-info`,
  message: `${PREFIX}-message`,
  messageText: `${PREFIX}-messageText`,
  close: `${PREFIX}-close`
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.snackbar}`]: {
    backgroundColor: "#313131",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    height: "60px",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow:
      "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  [`& .${classes.default}`]: {
    backgroundColor: "#313131"
  },
  [`& .${classes.success}`]: {
    backgroundColor: green[600]
  },
  [`& .${classes.error}`]: {
    backgroundColor: theme.palette.error.dark
  },
  [`& .${classes.warning}`]: {
    backgroundColor: amber[800]
  },
  [`& .${classes.info}`]: {
    backgroundColor: blue[500]
  },
  [`& .${classes.message}`]: {
    display: "flex",
    alignItems: "center",
    padding: "0",
    width: "100%"
  },
  [`& .${classes.messageText}`]: {
    marginRight: "10px",
    flex: "1"
  },
  [`& .${classes.close}`]: {
    marginRight: "0"
  }
}));
